import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useClientAuth } from "../lib/clientAuth";

// Gate for /c/dashboard and /c/projects/* — mirrors RequireAuth's shape
// for the owner side. If the client isn't signed in, redirect to /c/login
// while remembering where they were headed.
export function RequireClientAuth({ children }: { children: ReactNode }) {
  const { state } = useClientAuth();
  const location = useLocation();

  if (state.status === "loading") {
    return (
      <div className="mx-auto max-w-6xl px-6 py-20 text-center text-neutral-500">
        Loading…
      </div>
    );
  }

  if (state.status === "anon") {
    return <Navigate to="/c/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
